import { useAuth } from '@verantos-dev/core-annotation-tool';

import {
  useGetTotalProjectsCountQuery,
  useGetOrganizationsCountQuery,
  useGetConditionsCountQuery,
} from '../api/dashboardApiSlice';

export interface UseAdminCardsSectionResult {
  totalProjectsCount: number | null;
  isTotalProjectsCountLoading: boolean;
  organizationsCount: number | null;
  isOrganizationsCountLoading: boolean;
  conditionsCount: number | null;
  isConditionsCountLoading: boolean;
}

export const useAdminCardsSection = (): UseAdminCardsSectionResult => {
  const { user } = useAuth();
  const skip = !user.isAdmin;

  const {
    data: totalProjectsCountData,
    isLoading: isTotalProjectsCountLoading,
    isFetching: isTotalProjectsCountFetching,
  } = useGetTotalProjectsCountQuery(undefined, { skip });

  const {
    data: organizationsCountData,
    isLoading: isOrganizationsCountLoading,
    isFetching: isOrganizationsCountFetching,
  } = useGetOrganizationsCountQuery(undefined, { skip });

  const {
    data: conditionsCountData,
    isLoading: isConditionsCountLoading,
    isFetching: isConditionsCountFetching,
  } = useGetConditionsCountQuery(undefined, { skip });

  return {
    totalProjectsCount: totalProjectsCountData?.data?.count ?? null,
    isTotalProjectsCountLoading: isTotalProjectsCountLoading || isTotalProjectsCountFetching,
    organizationsCount: organizationsCountData?.data?.count ?? null,
    isOrganizationsCountLoading: isOrganizationsCountLoading || isOrganizationsCountFetching,
    conditionsCount: conditionsCountData?.data?.count ?? null,
    isConditionsCountLoading: isConditionsCountLoading || isConditionsCountFetching,
  };
};
